Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    toggleForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    toggleForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    toggleSpacingHorizontal: 12,
    toggleMotionDuration: "200ms",
    toggleMotionFunction: "ease",
    toggleTrackSpacingInset: 3,
    toggleTrackWidthMedium: 40,
    toggleTrackWidthLarge: 48,
    toggleTrackBorderWidth: 1,
    toggleTrackBorderRadius: 12,
    toggleTrackBorderColorSelectedDefault: "rgba(0, 0, 0, 0)",
    toggleTrackBorderColorSelectedDisabled: tokens.themeBorderPrimaryDisabled,
    toggleTrackBorderColorUnselectedDefault: tokens.themeBorderPrimaryDefault,
    toggleTrackBorderColorUnselectedDisabled: tokens.themeForegroundSecondaryDisabled,
    toggleTrackBackgroundColorSelectedDefault: tokens.themeForegroundAccentDefault,
    toggleTrackBackgroundColorSelectedHover: tokens.themeForegroundAccentHover,
    toggleTrackBackgroundColorSelectedPressed: tokens.themeForegroundAccentPressed,
    toggleTrackBackgroundColorSelectedDisabled: tokens.themeForegroundAccentDisabled,
    toggleTrackBackgroundColorUnselectedDefault: tokens.themeBackgroundPrimaryDefault,
    toggleTrackBackgroundColorUnselectedHover: tokens.themeBackgroundTertiaryDefault,
    toggleTrackBackgroundColorUnselectedPressed: tokens.themeBackgroundTertiaryHover,
    toggleTrackBackgroundColorUnselectedDisabled: tokens.themeBackgroundAlternateTertiaryFocus,
    toggleBallBorderRadius: 999,
    toggleBallDropShadowHoverPressedOffsetX: 0,
    toggleBallDropShadowHoverPressedOffsetY: 1,
    toggleBallDropShadowHoverPressedBlur: 2,
    toggleBallDropShadowHoverPressedSpread: 0,
    toggleBallDropShadowHoverPressedColor: "rgba(11, 12, 12, 0.16)",
    toggleBallBackgroundColorSelectedDefault: tokens.themeBackgroundPrimaryDefault,
    toggleBallBackgroundColorSelectedDisabled: tokens.themeBackgroundPrimaryDefault,
    toggleBallBackgroundColorUnselectedDefault: tokens.themeForegroundSecondaryDefault,
    toggleBallBackgroundColorUnselectedDisabled: tokens.themeForegroundSecondaryDisabled,
    toggleBallDiameterMedium: 12,
    toggleBallDiameterLarge: 16
  }
};